import { SpriteIcon } from 'types/icons';

export interface TagCategory {
    id: string;
    icon: SpriteIcon;
    i18nKey: string;
}

export const TAG_POPULAR_PSEUDO_CAT_ID = '0';

export const TAG_CATEGORIES: TagCategory[] = [
    { id: TAG_POPULAR_PSEUDO_CAT_ID, icon: 'star', i18nKey: 'Common.MostPopular' },
    { id: '10', icon: 'food-drink', i18nKey: 'Interests.Categories.Food' },
    { id: '11', icon: 'music', i18nKey: 'Interests.Categories.Music' },
    { id: '12', icon: 'tv', i18nKey: 'Interests.Categories.Movies' },
    { id: '13', icon: 'glasses', i18nKey: 'Interests.Categories.Fashion' },
    { id: '14', icon: 'sport', i18nKey: 'Interests.Categories.Sports' },
    { id: '15', icon: 'globe', i18nKey: 'Interests.Categories.Travel' },
    { id: '16', icon: 'briefcase', i18nKey: 'Interests.Categories.Profession' },
    { id: '17', icon: 'games', i18nKey: 'Interests.Categories.Games' },
    { id: '18', icon: 'guitar', i18nKey: 'Interests.Categories.Hobbies' },
    { id: '19', icon: 'book', i18nKey: 'Interests.Categories.Books' },
    { id: '20', icon: 'flower', i18nKey: 'Interests.Categories.Other' },
];

export const getIconByTagCategory = (categoryId: string): SpriteIcon | undefined =>
    TAG_CATEGORIES.find((e) => e.id === categoryId)?.icon;
